import { AccessTokenScopes } from '../authentication/context';

export default function getRequiredScopes(url: string) {
    if (!url) {
        return null;
    }

    const isAbsolute = /^[a-zA-Z]+:\/\//.test(url);

    if (isAbsolute) {
        return null;
    }

    if (url.startsWith('/')) {
        url = url.substring(1);
    }

    const resource = url.split('/')[0] + '.read';
    const scope: keyof AccessTokenScopes = resource as keyof AccessTokenScopes;

    return scope;
}
